export const SLATE_01 = "#282828";
export const SLATE_02 = "#4A4A4A";
export const SLATE_03 = "#A8A8A8";
export const SLATE_04 = "#DFDFDF";
export const SLATE_05 = "#F7F7F7";

export const BARRY_01 = "#172A30";
export const BARRY_02 = "#2B505B";
export const BARRY_03 = "#3F7484";
export const BARRY_04 = "#F3F8F9";

// red variants
export const DREAD = "#E85555";
export const DREAD_LIGHT = "#FAD7D7";
export const DREAD_DARK = "#BC1919";
export const RED = "#E85858";

// green variants
export const GREEN = "#269A5A";
export const GREEN_LIGHT = "#DAF6E7";
export const GREEN_DARK = "#155532";

// graphite variants
export const GRAPHITE_02 = "#687270";

// blue variants
export const DASH = "#4462DC";
export const DASH_DARK = "#4462DC";

// black
export const BLACK = "#091113";

export const WHITE = "#fff";

export const BORANGE = "#F09059";

// Filter Colours

export const FILTER_BLUE = "#98b1fe";

export const FILTER_DREAD = "#fc9ad1";

export const FILTER_GREEN = "#b4eea6";

export const FILTER_ORANGE = "#fdd68c";

// LMS THEME
export const SAPPHIRE_02 = "#2F4285";
export const SAPPHIRE_04 = "#AFB6F6";
export const SANDSTONE_01 = "#FFFAED";
